import React from 'react';
import { Tabs } from 'antd';

//引用的封装工具组件
import getSize from '../../../utils/getSize';


//各个tab页下的查询统计面板
import Xszytzxx from './xszytzxx';
import Zytztj from './zytztj';

//基础样式
import css from './index.css';


const TabPane = Tabs.TabPane;

class IndexComponent extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    /**
     * * 获取tab页
     * @memberof IndexComponent
     */
    getTabPanes = () => {

        const tabPanes = [
            <TabPane tab="调整信息详情" key="1"><Xszytzxx /></TabPane>,
            <TabPane tab="统计" key="2"><Zytztj /></TabPane>,
        ];

        return tabPanes;
    };

    render() {
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <Tabs defaultActiveKey={"1"}>
                    {this.getTabPanes()}
                </Tabs>
            </div>
        )
    }

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./components/tjcx/zytzxx/index.js